// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AppProtectedRouteImport } from './routes/_app/_protected'
import { Route as AppChecklistRouteImport } from './routes/_app/checklist'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AuthCompleteProfileRouteImport } from './routes/_auth/complete-profile'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthSigninRouteImport } from './routes/_auth/signin'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth/verify-email'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as ResourcesIndexRouteImport } from './routes/resources/index'
import { Route as ResourcesAmstar2RouteImport } from './routes/resources/amstar2'
import { Route as ResourcesAmstar2VsRobisRouteImport } from './routes/resources/amstar2-vs-robis'
import { Route as ResourcesRob1VsRob2RouteImport } from './routes/resources/rob1-vs-rob2'
import { Route as ResourcesRob2RouteImport } from './routes/resources/rob2'
import { Route as ResourcesRob2VsRobinsIRouteImport } from './routes/resources/rob2-vs-robins-i'
import { Route as ResourcesRobinsIRouteImport } from './routes/resources/robins-i'
import { Route as ResourcesRobinsIV1VsV2RouteImport } from './routes/resources/robins-i-v1-vs-v2'
import { Route as SecurityDisclosureRouteImport } from './routes/security_.disclosure'
import { Route as AppProtectedAdminRouteImport } from './routes/_app/_protected/admin'
import { Route as AppProtectedSettingsRouteImport } from './routes/_app/_protected/settings'
import { Route as AppChecklistIndexRouteImport } from './routes/_app/checklist.index'
import { Route as AppChecklistChecklistIdRouteImport } from './routes/_app/checklist.$checklistId'
import { Route as AppProtectedAdminIndexRouteImport } from './routes/_app/_protected/admin/index'
import { Route as AppProtectedAdminAnnouncementsRouteImport } from './routes/_app/_protected/admin/announcements'
import { Route as AppProtectedAdminDatabaseRouteImport } from './routes/_app/_protected/admin/database'
import { Route as AppProtectedAdminStorageRouteImport } from './routes/_app/_protected/admin/storage'
import { Route as AppProtectedProjectsProjectIdRouteImport } from './routes/_app/_protected/projects.$projectId'
import { Route as AppProtectedSettingsIndexRouteImport } from './routes/_app/_protected/settings/index'
import { Route as AppProtectedSettingsBillingRouteImport } from './routes/_app/_protected/settings/billing'
import { Route as AppProtectedSettingsIntegrationsRouteImport } from './routes/_app/_protected/settings/integrations'
import { Route as AppProtectedSettingsMembersRouteImport } from './routes/_app/_protected/settings/members'
import { Route as AppProtectedSettingsPlansRouteImport } from './routes/_app/_protected/settings/plans'
import { Route as AppProtectedSettingsPreferencesRouteImport } from './routes/_app/_protected/settings/preferences'
import { Route as AppProtectedSettingsProfileRouteImport } from './routes/_app/_protected/settings/profile'
import { Route as AppProtectedSettingsSecurityRouteImport } from './routes/_app/_protected/settings/security'
import { Route as AppProtectedSettingsWorkspaceRouteImport } from './routes/_app/_protected/settings/workspace'
import { Route as AppProtectedAdminBillingLedgerRouteImport } from './routes/_app/_protected/admin/billing.ledger'
import { Route as AppProtectedAdminBillingStripeToolsRouteImport } from './routes/_app/_protected/admin/billing.stripe-tools'
import { Route as AppProtectedAdminBillingStuckStatesRouteImport } from './routes/_app/_protected/admin/billing.stuck-states'
import { Route as AppProtectedAdminOrgsIndexRouteImport } from './routes/_app/_protected/admin/orgs.index'
import { Route as AppProtectedAdminOrgsOrgIdRouteImport } from './routes/_app/_protected/admin/orgs.$orgId'
import { Route as AppProtectedAdminProjectsIndexRouteImport } from './routes/_app/_protected/admin/projects.index'
import { Route as AppProtectedAdminProjectsProjectIdRouteImport } from './routes/_app/_protected/admin/projects.$projectId'
import { Route as AppProtectedAdminUsersIndexRouteImport } from './routes/_app/_protected/admin/users.index'
import { Route as AppProtectedAdminUsersUserIdRouteImport } from './routes/_app/_protected/admin/users.$userId'
import { Route as AppProtectedProjectsProjectIdStudiesStudyIdChecklistsChecklistIdRouteImport } from './routes/_app/_protected/projects.$projectId/studies.$studyId.checklists.$checklistId'
import { Route as AppProtectedProjectsProjectIdStudiesStudyIdReconcileChecklist1IdChecklist2IdRouteImport } from './routes/_app/_protected/projects.$projectId/studies.$studyId.reconcile.$checklist1Id.$checklist2Id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const SecurityRoute = SecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AppProtectedRoute = AppProtectedRouteImport.update({
            id: '/_protected',getParentRoute: () => AppRoute
          })
const AppChecklistRoute = AppChecklistRouteImport.update({
            id: '/checklist',path: '/checklist',getParentRoute: () => AppRoute
          })
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppRoute
          })
const AuthCompleteProfileRoute = AuthCompleteProfileRouteImport.update({
            id: '/complete-profile',path: '/complete-profile',getParentRoute: () => AuthRoute
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AuthRoute
          })
const AuthSigninRoute = AuthSigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => AuthRoute
          })
const AuthSignupRoute = AuthSignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => AuthRoute
          })
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => AuthRoute
          })
const InviteTokenRoute = InviteTokenRouteImport.update({
            id: '/invite/$token',path: '/invite/$token',getParentRoute: () => rootRouteImport
          })
const ResourcesIndexRoute = ResourcesIndexRouteImport.update({
            id: '/resources/',path: '/resources/',getParentRoute: () => rootRouteImport
          })
const ResourcesAmstar2Route = ResourcesAmstar2RouteImport.update({
            id: '/resources/amstar2',path: '/resources/amstar2',getParentRoute: () => rootRouteImport
          })
const ResourcesAmstar2VsRobisRoute = ResourcesAmstar2VsRobisRouteImport.update({
            id: '/resources/amstar2-vs-robis',path: '/resources/amstar2-vs-robis',getParentRoute: () => rootRouteImport
          })
const ResourcesRob1VsRob2Route = ResourcesRob1VsRob2RouteImport.update({
            id: '/resources/rob1-vs-rob2',path: '/resources/rob1-vs-rob2',getParentRoute: () => rootRouteImport
          })
const ResourcesRob2Route = ResourcesRob2RouteImport.update({
            id: '/resources/rob2',path: '/resources/rob2',getParentRoute: () => rootRouteImport
          })
const ResourcesRob2VsRobinsIRoute = ResourcesRob2VsRobinsIRouteImport.update({
            id: '/resources/rob2-vs-robins-i',path: '/resources/rob2-vs-robins-i',getParentRoute: () => rootRouteImport
          })
const ResourcesRobinsIRoute = ResourcesRobinsIRouteImport.update({
            id: '/resources/robins-i',path: '/resources/robins-i',getParentRoute: () => rootRouteImport
          })
const ResourcesRobinsIV1VsV2Route = ResourcesRobinsIV1VsV2RouteImport.update({
            id: '/resources/robins-i-v1-vs-v2',path: '/resources/robins-i-v1-vs-v2',getParentRoute: () => rootRouteImport
          })
const SecurityDisclosureRoute = SecurityDisclosureRouteImport.update({
            id: '/security_/disclosure',path: '/security/disclosure',getParentRoute: () => rootRouteImport
          })
const AppProtectedAdminRoute = AppProtectedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AppProtectedRoute
          })
const AppProtectedSettingsRoute = AppProtectedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppProtectedRoute
          })
const AppChecklistIndexRoute = AppChecklistIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppChecklistRoute
          })
const AppChecklistChecklistIdRoute = AppChecklistChecklistIdRouteImport.update({
            id: '/$checklistId',path: '/$checklistId',getParentRoute: () => AppChecklistRoute
          })
const AppProtectedAdminIndexRoute = AppProtectedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppProtectedAdminRoute
          })
const AppProtectedAdminAnnouncementsRoute = AppProtectedAdminAnnouncementsRouteImport.update({
            id: '/announcements',path: '/announcements',getParentRoute: () => AppProtectedAdminRoute
          })
const AppProtectedAdminDatabaseRoute = AppProtectedAdminDatabaseRouteImport.update({
            id: '/database',path: '/database',getParentRoute: () => AppProtectedAdminRoute
          })
const AppProtectedAdminStorageRoute = AppProtectedAdminStorageRouteImport.update({
            id: '/storage',path: '/storage',getParentRoute: () => AppProtectedAdminRoute
          })
const AppProtectedProjectsProjectIdRoute = AppProtectedProjectsProjectIdRouteImport.update({
            id: '/projects/$projectId',path: '/projects/$projectId',getParentRoute: () => AppProtectedRoute
          })
const AppProtectedSettingsIndexRoute = AppProtectedSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppProtectedSettingsRoute
          })
const AppProtectedSettingsBillingRoute = AppProtectedSettingsBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AppProtectedSettingsRoute
          })
const AppProtectedSettingsIntegrationsRoute = AppProtectedSettingsIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => AppProtectedSettingsRoute
          })
const AppProtectedSettingsMembersRoute = AppProtectedSettingsMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => AppProtectedSettingsRoute
          })
const AppProtectedSettingsPlansRoute = AppProtectedSettingsPlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => AppProtectedSettingsRoute
          })
const AppProtectedSettingsPreferencesRoute = AppProtectedSettingsPreferencesRouteImport.update({
            id: '/preferences',path: '/preferences',getParentRoute: () => AppProtectedSettingsRoute
          })
const AppProtectedSettingsProfileRoute = AppProtectedSettingsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AppProtectedSettingsRoute
          })
const AppProtectedSettingsSecurityRoute = AppProtectedSettingsSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => AppProtectedSettingsRoute
          })
const AppProtectedSettingsWorkspaceRoute = AppProtectedSettingsWorkspaceRouteImport.update({
            id: '/workspace',path: '/workspace',getParentRoute: () => AppProtectedSettingsRoute
          })
const AppProtectedAdminBillingLedgerRoute = AppProtectedAdminBillingLedgerRouteImport.update({
            id: '/billing/ledger',path: '/billing/ledger',getParentRoute: () => AppProtectedAdminRoute
          })
const AppProtectedAdminBillingStripeToolsRoute = AppProtectedAdminBillingStripeToolsRouteImport.update({
            id: '/billing/stripe-tools',path: '/billing/stripe-tools',getParentRoute: () => AppProtectedAdminRoute
          })
const AppProtectedAdminBillingStuckStatesRoute = AppProtectedAdminBillingStuckStatesRouteImport.update({
            id: '/billing/stuck-states',path: '/billing/stuck-states',getParentRoute: () => AppProtectedAdminRoute
          })
const AppProtectedAdminOrgsIndexRoute = AppProtectedAdminOrgsIndexRouteImport.update({
            id: '/orgs/',path: '/orgs/',getParentRoute: () => AppProtectedAdminRoute
          })
const AppProtectedAdminOrgsOrgIdRoute = AppProtectedAdminOrgsOrgIdRouteImport.update({
            id: '/orgs/$orgId',path: '/orgs/$orgId',getParentRoute: () => AppProtectedAdminRoute
          })
const AppProtectedAdminProjectsIndexRoute = AppProtectedAdminProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => AppProtectedAdminRoute
          })
const AppProtectedAdminProjectsProjectIdRoute = AppProtectedAdminProjectsProjectIdRouteImport.update({
            id: '/projects/$projectId',path: '/projects/$projectId',getParentRoute: () => AppProtectedAdminRoute
          })
const AppProtectedAdminUsersIndexRoute = AppProtectedAdminUsersIndexRouteImport.update({
            id: '/users/',path: '/users/',getParentRoute: () => AppProtectedAdminRoute
          })
const AppProtectedAdminUsersUserIdRoute = AppProtectedAdminUsersUserIdRouteImport.update({
            id: '/users/$userId',path: '/users/$userId',getParentRoute: () => AppProtectedAdminRoute
          })
const AppProtectedProjectsProjectIdStudiesStudyIdChecklistsChecklistIdRoute = AppProtectedProjectsProjectIdStudiesStudyIdChecklistsChecklistIdRouteImport.update({
            id: '/studies/$studyId/checklists/$checklistId',path: '/studies/$studyId/checklists/$checklistId',getParentRoute: () => AppProtectedProjectsProjectIdRoute
          })
const AppProtectedProjectsProjectIdStudiesStudyIdReconcileChecklist1IdChecklist2IdRoute = AppProtectedProjectsProjectIdStudiesStudyIdReconcileChecklist1IdChecklist2IdRouteImport.update({
            id: '/studies/$studyId/reconcile/$checklist1Id/$checklist2Id',path: '/studies/$studyId/reconcile/$checklist1Id/$checklist2Id',getParentRoute: () => AppProtectedProjectsProjectIdRoute
          })





const AppProtectedAdminRouteChildren = {
  AppProtectedAdminAnnouncementsRoute: AppProtectedAdminAnnouncementsRoute,AppProtectedAdminDatabaseRoute: AppProtectedAdminDatabaseRoute,AppProtectedAdminStorageRoute: AppProtectedAdminStorageRoute,AppProtectedAdminIndexRoute: AppProtectedAdminIndexRoute,AppProtectedAdminBillingLedgerRoute: AppProtectedAdminBillingLedgerRoute,AppProtectedAdminBillingStripeToolsRoute: AppProtectedAdminBillingStripeToolsRoute,AppProtectedAdminBillingStuckStatesRoute: AppProtectedAdminBillingStuckStatesRoute,AppProtectedAdminOrgsOrgIdRoute: AppProtectedAdminOrgsOrgIdRoute,AppProtectedAdminProjectsProjectIdRoute: AppProtectedAdminProjectsProjectIdRoute,AppProtectedAdminUsersUserIdRoute: AppProtectedAdminUsersUserIdRoute,AppProtectedAdminOrgsIndexRoute: AppProtectedAdminOrgsIndexRoute,AppProtectedAdminProjectsIndexRoute: AppProtectedAdminProjectsIndexRoute,AppProtectedAdminUsersIndexRoute: AppProtectedAdminUsersIndexRoute
}

const AppProtectedAdminRouteWithChildren = AppProtectedAdminRoute._addFileChildren(AppProtectedAdminRouteChildren)




const AppProtectedSettingsRouteChildren = {
  AppProtectedSettingsBillingRoute: AppProtectedSettingsBillingRoute,AppProtectedSettingsIntegrationsRoute: AppProtectedSettingsIntegrationsRoute,AppProtectedSettingsMembersRoute: AppProtectedSettingsMembersRoute,AppProtectedSettingsPlansRoute: AppProtectedSettingsPlansRoute,AppProtectedSettingsPreferencesRoute: AppProtectedSettingsPreferencesRoute,AppProtectedSettingsProfileRoute: AppProtectedSettingsProfileRoute,AppProtectedSettingsSecurityRoute: AppProtectedSettingsSecurityRoute,AppProtectedSettingsWorkspaceRoute: AppProtectedSettingsWorkspaceRoute,AppProtectedSettingsIndexRoute: AppProtectedSettingsIndexRoute
}

const AppProtectedSettingsRouteWithChildren = AppProtectedSettingsRoute._addFileChildren(AppProtectedSettingsRouteChildren)




const AppProtectedProjectsProjectIdRouteChildren = {
  AppProtectedProjectsProjectIdStudiesStudyIdChecklistsChecklistIdRoute: AppProtectedProjectsProjectIdStudiesStudyIdChecklistsChecklistIdRoute,AppProtectedProjectsProjectIdStudiesStudyIdReconcileChecklist1IdChecklist2IdRoute: AppProtectedProjectsProjectIdStudiesStudyIdReconcileChecklist1IdChecklist2IdRoute
}

const AppProtectedProjectsProjectIdRouteWithChildren = AppProtectedProjectsProjectIdRoute._addFileChildren(AppProtectedProjectsProjectIdRouteChildren)



const AppProtectedRouteChildren = {
  AppProtectedAdminRoute: AppProtectedAdminRouteWithChildren,AppProtectedSettingsRoute: AppProtectedSettingsRouteWithChildren,AppProtectedProjectsProjectIdRoute: AppProtectedProjectsProjectIdRouteWithChildren
}

const AppProtectedRouteWithChildren = AppProtectedRoute._addFileChildren(AppProtectedRouteChildren)




const AppChecklistRouteChildren = {
  AppChecklistChecklistIdRoute: AppChecklistChecklistIdRoute,AppChecklistIndexRoute: AppChecklistIndexRoute
}

const AppChecklistRouteWithChildren = AppChecklistRoute._addFileChildren(AppChecklistRouteChildren)



const AppRouteChildren = {
  AppProtectedRoute: AppProtectedRouteWithChildren,AppChecklistRoute: AppChecklistRouteWithChildren,AppDashboardRoute: AppDashboardRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)




const AuthRouteChildren = {
  AuthCompleteProfileRoute: AuthCompleteProfileRoute,AuthResetPasswordRoute: AuthResetPasswordRoute,AuthSigninRoute: AuthSigninRoute,AuthSignupRoute: AuthSignupRoute,AuthVerifyEmailRoute: AuthVerifyEmailRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,AuthRoute: AuthRouteWithChildren,AboutRoute: AboutRoute,ContactRoute: ContactRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,SecurityRoute: SecurityRoute,TermsRoute: TermsRoute,InviteTokenRoute: InviteTokenRoute,ResourcesAmstar2Route: ResourcesAmstar2Route,ResourcesAmstar2VsRobisRoute: ResourcesAmstar2VsRobisRoute,ResourcesRob1VsRob2Route: ResourcesRob1VsRob2Route,ResourcesRob2Route: ResourcesRob2Route,ResourcesRob2VsRobinsIRoute: ResourcesRob2VsRobinsIRoute,ResourcesRobinsIRoute: ResourcesRobinsIRoute,ResourcesRobinsIV1VsV2Route: ResourcesRobinsIV1VsV2Route,SecurityDisclosureRoute: SecurityDisclosureRoute,ResourcesIndexRoute: ResourcesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)